import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import { ETitles } from 'Types/globals';

/* Returns strapi title */

export const useStrapiTitles = (titles: ETitles[]) => {
  const strapi_request = useSelector((state: IApplicationState) => state.strapiReducer);

  const strapi_titles = titles.reduce((accumulator, identifier) => {
    const title = strapi_request?.data?.titles?.find(title => title?.identifier === identifier);

    if (title) {
      accumulator.push(title?.title);
    } else {
      accumulator.push('');
    }


    return accumulator;
  }, []);

  return strapi_titles;
};
